<template>
    <div>
        <modal name="modal-view-chantier" height="auto" :adaptive="true" width="1100px" classes="rounded-[2.5rem] shadow-2xl overflow-hidden">
            <div class="bg-white p-2">
                <div class="overflow-y-auto max-h-[90vh] min-h-[80vh] rounded-[2rem] bg-gray-50/50 p-8">
                    <div v-if="selectedViewChantier">
                        <div class="flex justify-between items-center mb-8">
                             <div class="flex items-center gap-4">
                                <div class="w-12 h-12 rounded-2xl bg-orange-600 text-white flex items-center justify-center shadow-lg shadow-orange-200">
                                    <i class="fas fa-hard-hat"></i>
                                </div>
                                <h2 class="text-2xl font-black tracking-tight">Détails du chantier</h2>
                             </div>
                             <button @click="$modal.hide('modal-view-chantier')" class="w-10 h-10 rounded-full hover:bg-white hover:shadow-md transition-all flex items-center justify-center text-slate-400 hover:text-red-500">
                                <i class="fas fa-times"></i>
                             </button>
                        </div>
                        <chantier-view :chantier-id="selectedViewChantier.id" @chantier-ended="getChantiers(); $modal.hide('modal-view-chantier')" />
                    </div>
                </div>
            </div>
        </modal>

        <div v-if="loadingGetChantiers" class="text-center my-5">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
        <div v-else>
            <div v-if="chantiers.length === 0" class="text-center my-5">
                <p>Aucun chantier trouvé.</p>
            </div>
            <div v-else>
                <div class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                    <table class="w-full text-sm text-left">
                        <thead class="bg-gray-100 text-gray-600 uppercase text-xs">
                            <tr>
                                <th class="px-6 py-3">Terminé</th>
                                <th class="px-6 py-3">Date de création</th>
                                <th class="px-6 py-3">Adresse d'intervention</th>
                                <th class="px-6 py-3">Nombre d'interventions</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100">
                            <tr v-for="chantier in chantiers" :key="chantier.id" @click="displayChantierView(chantier)" class="hover:bg-red-100 cursor-pointer transition">
                                <td class="px-6 py-3">
                                    <i class="fas" :class="chantier.terminer ? 'fa-check text-green-500' : 'fa-hourglass-half text-orange-500'"></i>
                                    <span class="text-xs font-light ml-1.5">{{ chantier.statut.libelle }}</span>
                                </td>
                                <td class="px-6 py-3">{{ chantier.created_at | momentDateTime }}</td>
                                <td class="px-6 py-3">{{ chantier.adresse.adresse1 + ', ' + chantier.adresse.code_postal + ' ' + chantier.adresse.ville }}</td>
                                <td class="px-6 py-3">{{ chantier.interventions.length }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import ChantierView from '../../Chantier/Components/ChantierView.vue';

export default {
    props: {
        clientId: {
            required: true
        },
    },

    components: {
        ChantierView
    },

    data() {
        return {
            chantiers: [],

            selectedViewChantier: null,

            loadingGetChantiers: false,
        }
    },

    filters: {
        momentDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            }
            return '-'
        },
        momentDateTime(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY HH:mm')
            }
            return '-'
        }
    },

    methods: {
        async getChantiers() {
            this.loadingGetChantiers = true;
            let response = await this.$request.post('/clients/chantiers/list', {
                client_id: this.clientId
            })
            this.chantiers = response
            this.loadingGetChantiers = false;
        },

        displayChantierView(chantier) {
            this.selectedViewChantier = chantier;
            this.$nextTick(() => {
                this.$modal.show('modal-view-chantier');
            })
        },
    },
    mounted () {
        this.getChantiers();
    },
}
</script>

<style lang="scss" scoped>

</style>